module.exports = __webpack_public_path__ + "static/media/report-recycle.c4c21fba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/report-recycle.svg
// module id = 392
// module chunks = 0